<template>
  <ArticleDetail
    :articleId="id"
    :pageTitle="pname"
    :categoryId="pid"
    listPath="/latestbroadcast"
    detailPath="/latestbroadcast/latestdetail"
    :showCover="false"
    :showMeta="true"
  />
</template>

<script>
export default {
  name: 'LatestDetail',
  data() {
    return {
      id: 0,
      pname: '',
      pid: 0
    }
  },
  watch: {
    $route: {
      handler(newval) {
        this.id = newval.query.id
        this.pname = newval.query.pname
        this.pid = newval.query.pid
      },
      deep: true
    }
  },
  created() {
    this.id = this.$route.query.id
    this.pname = this.$route.query.pname
    this.pid = this.$route.query.pid
  }
}
</script>
